<template>
    <div>
        <div style="width: 50%;margin: 20px 0;">
            <span class="searchName" >原辅料:</span>
            <el-input
                    class="mr10"
                    placeholder="原辅料 搜索"
                    v-model="cpinput"
                    clearable>
            </el-input>
            <el-button type="primary" @click="searchData" style="margin-left: 30px" :class="baseerp+'btn'">搜索</el-button>
        </div>
        <el-table
                border
                ref="multipleTable"
                :data="detailsData"
                row-key="vc_unique"
                height="485"
                tooltip-effect="dark"
                :row-class-name="tableRowClassName"
                @selection-change="handleSelectionChange"
                style="width: 100%">
            <el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="materials"
                    label="原辅料"
                    width=""
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="xqnum"
                    label="单吨需求量"
                    width=""
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="protype"
                    label="类型"
                    width=""
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <div class="tbRight">
            <div class="paginationBox textRig" >
                <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="pageCurrentChange"
                        :current-page.sync="currentPage"
                        :total="tableTotal">
                </el-pagination>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 20px">

            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    // import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "ProductDetails",
        props:{
            productDetails:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                cpinput:"",
                multipleSelection:"",
                detailsData:[],
                currentPage:0,
                tableTotal:0,
                pageSize:1,
                pageCount:1,
                gsid:0,
                ckid:0,
                baseerp:"",
                mid:0,
            }
        },
        mounted() {
            this.baseerp=baseerp;
            this.gsid=this.productDetails.gsid;
            this.ckid=this.productDetails.ckid;
            //console.log("mounted")
            //this.getProductList();
        },
        methods: {
            async getProductList(){
                let param={
                    i_mid: this.mid,
                    page_size:this.pageSize,
                    page_count:10,
                    i_gsid:this.gsid,
                    i_ckid:this.ckid,
                    vc_name:this.cpinput,
                };
                let res=await API.getProductList(param);
                if(res.code==1){
                    this.detailsData=res.data;
                    this.tableTotal=res.count;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            searchData(){
                this.pageSize=1;
                this.currentPage=1;
                //this.getProductList();
            },
            cancel(){
                this.$emit('closePop');
            },

            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                //console.log(val)
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }
            },
            saveForm(){
                //this.$emit('transValue',this.multipleSelection);
                this.$emit('closePop');
            },
            pageCurrentChange(val){
                this.pageSize=val;
                this.currentPage=val;
                //this.getProductList();
            },
        },
    }
</script>

<style lang="scss" scoped>
.searchName{
    width: 100px; display: inline-block;vertical-align: middle;text-align: center;
}
    .mr10{
        width: 50%;
    }

/deep/{
    .el-table td,.el-table td, .el-table th {
        padding: 10px 0;
    }
    .danger-row{
        color: #999;
    }
}
</style>